<template>
	<edit></edit>
</template>

<script>
	import edit from './freight_template_edit.vue'
	
	export default {
		name: 'freight_template_add',
		
		components: {
			edit
		}
	}
</script>